module.exports = __webpack_public_path__ + "img/4.9b5a49c2.gif";